import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type DuplicateBoardTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type DuplicateBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<DuplicateBoardTask>, 'sourceBoardName'>;
  onCancel: () => void;
};

export const DuplicateBoardPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { sourceBoardName } }: DuplicateBoardPanelInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const title = ui2026 ? 'Duplicating board' : `Duplicating "${sourceBoardName}"`;

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle data-testid="DUPLICATING_BOARD_TITLE">{ui2026 ? `${title}…` : title}</FileStatusTitle>}
        buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
      />
    );
  },
);

DuplicateBoardPanelInProgressPanelItem.displayName = 'DuplicateBoardPanelInProgressPanelItem';
